// @ts-nocheck

import { RouterActionTypes } from '../types/actions/router';

export const routeHasChanged = ({ pathname, hash }) => ({
  type: RouterActionTypes.ROUTE_HAS_CHANGED,
  payload: {
    pathname,
    hash,
  },
});
